import { Component, OnInit,Inject } from '@angular/core';
import { DOCUMENT, formatDate, DatePipe } from '@angular/common';
import { HomepageService } from '../../../services/homepage.service';
import { CookieService } from 'ngx-cookie-service';
import { DatepickerOptions } from 'ng2-datepicker';
import {DragDropModule, moveItemInArray} from '@angular/cdk/drag-drop';
import * as moment from 'moment';
import { TenantService } from '../../../services/tenant.service';

@Component({
  selector: 'app-bulletins-list',
  templateUrl: './bulletins-list.component.html',
  styleUrls: ['./bulletins-list.component.css']
})
export class BulletinsListComponent implements OnInit {
	responseAPIstatus:boolean = true;
	bulletinsList: any;
  canEdit : boolean = false;
  showDate : boolean = false;
  editMode : boolean = false;
  saveBulletin : boolean = false;
  loations : any = [];
  date: any =  new Date(Date.now());
   tetent: any = '';
  confiGurationSetting: any = '*';
  token: any = ''; 
  constructor(@Inject(DOCUMENT) private document: Document, private homepageService: HomepageService, private cookieService: CookieService, private tenantService: TenantService) { 
      //if(this.cookieService.check( 'info')){
if (localStorage.getItem('info') != null){
      this.optionsEditor.requestHeaders.Authorization = 'Bearer '+localStorage.getItem('token');  
    }
    this.optionsEditor.requestHeaders.tenant = this.tenantService.tenant;
    this.optionsEditor.requestHeaders.configuration = this.tenantService.configurationSetting;
  }

  //Set editor options.
 public optionsEditor: any = {
  key: '6LF5g1D4A3B2B5D5E4F-11SLJCKHXOSLMc1YGSGb1ZXHSe1CgB5A4D4A3E3C2A13A19B6C6==',  
  toolbarInline: false,
  attribution:false,
  fileUpload: false,
    toolbarVisibleWithoutSelection: true,
    imageStyles: {
      class1: 'Class 1',
      class2: 'Class 2'
    },
    imageUploadMethod: 'post',
    requestHeaders: {
      tenant: '', 
      configuration : this.confiGurationSetting,
      Authorization:''
    },
    imageUploadURL: 'https://api.library.site/v1/bulletin/bulletinimage/upload',  
    events: {
      'image.uploaded': function (response) {
         var img_url = JSON.parse(response).data.url;
         this.image.insert(img_url, false, null, this.image.get(), response);       
         return false;
      }
    },
    toolbarButtons: {
      moreText: { buttons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor', 'inlineClass', 'inlineStyle', 'clearFormatting'] },
      moreParagraph: { buttons: ['alignLeft', 'alignCenter', 'formatOLSimple', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'paragraphStyle', 'lineHeight', 'outdent', 'indent', 'quote'] },
      moreRich: { buttons: ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertHR'] },
      moreMisc: { buttons: ['undo', 'redo', 'fullscreen', 'print', 'getPDF', 'spellChecker', 'selectAll', 'html', 'help'], align: 'right', buttonsVisible: 2 }
    },
    imageEditButtons: ['imageReplace', 'imageAlign', 'imageRemove', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove', '-', 'imageDisplay', 'imageStyle', 'imageAlt', 'imageSize']
  };

  //Options for date picker.
  options: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2030,
    //displayFormat: 'MMM D[,] YYYY',
    //barTitleFormat: 'MMMM YYYY',
    //dayNamesFormat: 'dd',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
   // locale: frLocale,
    minDate: new Date(Date.now()), // Minimal selectable date
    maxDate: new Date(Date.now()),  // Maximal selectable date
    //barTitleIfEmpty: 'Select a date',
    placeholder: 'Select  date', // HTML input placeholder attribute (default: '')
    //addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
   // addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    //fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    //useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };


  // Setting options for editors.
  public option = { 
    animation: 150,
    handle: '.my-handle',
    sort: true,
    group: 'widgets', 
    direction : 'vertical', 
    dragoverBubble: true,
    removeCloneOnHide: false ,
    onUpdate: (event: any) => {
      this.onSortFinish(event);
    }
  }

	ngOnInit() {
  	this.document.body.classList.add('inner-page');
    this.document.body.classList.remove('list');
    if(this.cookieService.check('patron')){
      var permissions = JSON.parse(this.cookieService.get('patronPermissions'));
      this.canEdit = permissions.opacAdmin;
    }

    //Get settings of library.
    this.homepageService.getConfig().subscribe((data:any) => {
      var tnt = data.data.tenantCode.toLowerCase();
      var slctloc = this.cookieService.get('selectedlocation'+tnt);
      var locData = {};
      data.data.settings.location.locations.forEach((loc) => {
        if(loc.id == slctloc){
            locData = {'id' : loc.id, 'name' : loc.name};
        }
      });
      this.loations = locData;      
    });

    //To get bulletin lists.
    this.homepageService.getBulletinsList().subscribe((data:any) => {
      this.responseAPIstatus = false;
     	this.bulletinsList = data.data;
    });
  }
  

  //show arrange button
  editModeToggle(){
    if(this.editMode == true){
      this.editMode = false;
      $('body').removeClass('manage-view');
    }else{
      this.editMode = true;
      $('body').addClass('manage-view');
    }
  }

  //sort bulletins
  onSortFinish(evt){
    var sortedBulletins = [];
    moveItemInArray(this.bulletinsList, evt.previousIndex, evt.currentIndex);
    this.bulletinsList.forEach((data,key)=>{
      var temp = {
        "BulletinId":data.id,
        "ListOrderNo":key
      };
      sortedBulletins.push(temp);
    });
    var token = localStorage.getItem('token');
    this.homepageService.rearrangeBulletin(sortedBulletins, token).subscribe((data:any) => {
    },(error)=>{
    });
  }

  //Show date input.
  showDateInput(event){
    if(this.showDate === true){
      this.showDate = false;
    } else {
      this.showDate = true;
    }
  }

  //Save bulletin method in list.
  saveBulletinMethod(event){
    this.saveBulletin = true;
    var bHeadline = $.trim($('#bHeadline').val().toString());
    var bcontent = $.trim($('#bContent').val().toString());
    var bLocation = $.trim($('input[name="selectlocation"]:checked').val().toString());
    if(bLocation == '' || bLocation == null){
      bLocation = null;
      let loc: string = sessionStorage.getItem('lastSearchLocation');
      bLocation =  loc;
    }
    var bDate:any = null;
    if($('#bIsDate').is(':checked')){
      //bDate = $.trim($('#datepickerNg').find('.ngx-datepicker-input').val().toString());
      bDate = $.trim($('#bDate').find('input').val().toString());
      let bDate_new = moment(bDate,"MMM DD YYYY");
      let bDate_new2 = bDate_new.format("MM-DD-YYYY");
      bDate = bDate_new2;
    }
    var token = localStorage.getItem('token');
    this.homepageService.saveBulletin(bHeadline, bcontent, bLocation, bDate, token).subscribe((data:any) => {
      this.saveBulletin = false;
      this.responseAPIstatus = true;
      this.homepageService.getBulletinsList().subscribe((data:any) => {
        this.responseAPIstatus = false;
        this.bulletinsList = data.data;
      });
      $('#closeBulletinAdd').trigger('click');  
    });
  }
}

